import {localDateFormat} from 'common/formats';
import dayjs from 'dayjs';
import {mixed, date, string, DateSchema} from 'yup';
import {CONTEXT_SEND_PARAMETER} from '../constants';

export const localDate = () =>
   mixed().when(CONTEXT_SEND_PARAMETER, {
      is: true,
      then: string().transform(function (val, origin) {
         // console.debug(val, origin);
         if (this.isType(val) && val.length === localDateFormat.length) {
            return val;
         }

         const day = dayjs(origin);
         if (!day.isValid()) return null;

         return day.format(localDateFormat);
      }),
      otherwise: date(),
   }) as DateSchema<Date>;
